import { useContext, useState } from "react";
import { Navbar, Container } from "react-bootstrap";
import "./BusinessGroupForm.css"; // Import custom CSS
import { AppThemeContext } from "../../../../../context/AppThemeContext";
import { BaseUrl } from "../../../../../api/AxiosApi";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";

function BusinessGroupForm({ show, handleClose }) {
    const User_ID = localStorage.getItem("LOGIN_ID")
    const { PrimaryColor } = useContext(AppThemeContext);
    const [formData, setFormData] = useState({
        groupName: "",
        groupAddress: "",
        email: "",
        password: "",

    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };


    console.log("formdata", formData)

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const queryParams = new URLSearchParams({
                Group_Name: formData.groupName,
                Address: formData.groupAddress,
                Mail_ID: formData.email,
                Password: formData.password,
                SKey: "XYZ"
            }).toString();

            const formBody = new URLSearchParams({
                USER_ID: User_ID,
                Group_ID: "",
                TYPE_ID:"I"
            }).toString();

            const finalUrl = `${BaseUrl}CMN_10_Update/iGroup?${queryParams}`;
            console.log("API URL:", finalUrl);

            const response = await fetch(finalUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded", // ✅ Correct header
                },
                body: formBody
            });

            console.log("API Response:", response);

            if (!response.ok) {
                throw new Error("Failed to create user");
            }

            // const result = await response.json();
            // console.log("API Response Data:", result);

            const rawResponse = await response.text();
            console.log("Raw API Response:", rawResponse); // ✅ पहले इसे print करें

            const result = JSON.parse(rawResponse);
            console.log("API Response Data:", result);


            if (result.success) {
                setFormData({
                    groupName: "",
                    groupAddress: "",
                    email: "",
                    password: ""
                });
            }

        } catch (error) {
            console.error("Error creating user:", error);
        }
    };




    return (
        <>

            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton className="modal-header-custom" style={{ backgroundColor: PrimaryColor }}>
                    <Modal.Title>Add Group Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-md-12">
                                <Form.Group className="mb-3">
                                    <Form.Label>Group/Company Name</Form.Label>
                                    <Form.Control type="text" name="groupName" value={formData.groupName} onChange={handleChange} />
                                </Form.Group>
                            </div>



                            <div className="col-md-12">
                                <Form.Group className="mb-3">
                                    <Form.Label>Group/Company Address</Form.Label>
                                    <Form.Control type="text" name="groupAddress" value={formData.groupAddress} onChange={handleChange} />
                                </Form.Group>
                            </div>


                            <div className="col-md-12">
                                <Form.Group className="mb-3">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control type="text" name="email" value={formData.email} onChange={handleChange} />
                                </Form.Group>
                            </div>


                            

                            <div className="col-md-12">
                                <Form.Group className="mb-3">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control type="text" name="password" value={formData.password} onChange={handleChange} />
                                </Form.Group>
                            </div>


                        </div>

                        <Modal.Footer>
                            <Button onClick={handleClose} style={{ backgroundColor: PrimaryColor }}>
                                Cancel
                            </Button>
                            <Button type="submit" style={{ backgroundColor: PrimaryColor }}>
                                Add Group
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal.Body>
            </Modal>



        </>
    );
}

export default BusinessGroupForm;


// import { useContext, useState } from "react";
// import { Navbar, Container } from "react-bootstrap";
// import "./BusinessGroupForm.css"; // Import custom CSS
// import { AppThemeContext } from "../../../../../context/AppThemeContext";
// import { BaseUrl } from "../../../../../api/AxiosApi";
// import Button from "react-bootstrap/Button";
// import Form from "react-bootstrap/Form";
// import Modal from "react-bootstrap/Modal";

// function BusinessGroupForm({ show, handleClose }) {
//     const User_ID = localStorage.getItem("LOGIN_ID")
//     const { PrimaryColor } = useContext(AppThemeContext);
//     const [formData, setFormData] = useState({
//         groupName: "",
//         groupAddress: "",
//         email: "",
//         password: "",

//     });

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData((prevData) => ({
//             ...prevData,
//             [name]: value,
//         }));
//     };


//     console.log("formdata", formData)

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             const queryParams = new URLSearchParams({
//                 Group_Name: formData.groupName,
//                 Address: formData.groupAddress,
//                 Mail_ID: formData.email,
//                 Password: formData.password,
//                 SKey: "XYZ"
//             }).toString();

//             const formBody = new URLSearchParams({
//                 USER_ID: User_ID,
//                 Group_ID: ""
//             }).toString();

//             const finalUrl = `${BaseUrl}CMN_10_Update/iGroup?${queryParams}`;
//             console.log("API URL:", finalUrl);

//             const response = await fetch(finalUrl, {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/x-www-form-urlencoded", // ✅ Correct header
//                 },
//                 body: formBody
//             });

//             console.log("API Response:", response);

//             if (!response.ok) {
//                 throw new Error("Failed to create user");
//             }

//             // const result = await response.json();
//             // console.log("API Response Data:", result);

//             const rawResponse = await response.text();
//             console.log("Raw API Response:", rawResponse); // ✅ पहले इसे print करें

//             const result = JSON.parse(rawResponse);
//             console.log("API Response Data:", result);


//             if (result.success) {
//                 setFormData({
//                     groupName: "",
//                     groupAddress: "",
//                     email: "",
//                     password: ""
//                 });
//             }

//         } catch (error) {
//             console.error("Error creating user:", error);
//         }
//     };




//     return (
//         <>

//             <Modal show={show} onHide={handleClose} centered>
//                 <Modal.Header closeButton className="modal-header-custom" style={{ backgroundColor: PrimaryColor }}>
//                     <Modal.Title>Add Group Details</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <Form onSubmit={handleSubmit}>
//                         <div className="row">
//                             <div className="col-md-12">
//                                 <Form.Group className="mb-3">
//                                     <Form.Label>Group/Company Name</Form.Label>
//                                     <Form.Control type="text" name="groupName" value={formData.groupName} onChange={handleChange} />
//                                 </Form.Group>
//                             </div>



//                             <div className="col-md-12">
//                                 <Form.Group className="mb-3">
//                                     <Form.Label>Group/Company Address</Form.Label>
//                                     <Form.Control type="text" name="groupAddress" value={formData.groupAddress} onChange={handleChange} />
//                                 </Form.Group>
//                             </div>


//                             <div className="col-md-12">
//                                 <Form.Group className="mb-3">
//                                     <Form.Label>Email</Form.Label>
//                                     <Form.Control type="email" name="email" value={formData.email} onChange={handleChange} />
//                                 </Form.Group>
//                             </div>


                            

//                             <div className="col-md-12">
//                                 <Form.Group className="mb-3">
//                                     <Form.Label>Password</Form.Label>
//                                     <Form.Control type="text" name="password" value={formData.password} onChange={handleChange} />
//                                 </Form.Group>
//                             </div>


//                         </div>

//                         <Modal.Footer>
//                             <Button onClick={handleClose} style={{ backgroundColor: PrimaryColor }}>
//                                 Cancel
//                             </Button>
//                             <Button type="submit" style={{ backgroundColor: PrimaryColor }}>
//                                 Add Group
//                             </Button>
//                         </Modal.Footer>
//                     </Form>
//                 </Modal.Body>
//             </Modal>



//         </>
//     );
// }

// export default BusinessGroupForm;